import React from "react";
import { Stack, CircularProgress } from "@mui/material";

export default function Loading() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="calc(100vh - 72px)"
    >
      <CircularProgress />
    </Stack>
  );
}
